import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { UPCOMING_EVENTS_EVENT_FRAGMENT } from '../fragments/upcomingEventsEvent'

export const UPCOMING_EVENTS = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${UPCOMING_EVENTS_EVENT_FRAGMENT}

  query upcomingEvents(
    $filter: ListEventsFilter!
    $sort: [ListEventsSort!]!
    $offset: Int
    $limit: Int
  ) {
    listEvents(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
      ... on ListEventsOutput {
        events {
          ...UpcomingEventsEvent
        }
        count
      }
      ... on ListEventsErrorOutput {
        errors {
          name
          dateStartAfter
          dateStartBefore
          addressGeom
          sort
          limit
          offset
        }
      }
      ...ServerError
      ...UnauthorizedError
      ...UnauthenticatedError
    }
  }
`
